// 2022-01-25: Since PerformanceNavigationTiming.type is still an experimental browser feature and not yet officially supported by Angular, types are added manually.
// https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type

type PerformanceNavigationTimingType = 'navigate' | 'reload' | 'back_forward' | 'prerender';
interface PerformanceNavigationTiming {
  type?: PerformanceNavigationTimingType;
}

export class PageLoadTypeDetector {
  constructor(private window: Window) {}

  isReload(): boolean {
    const pageLoadType: PerformanceNavigationTimingType | undefined = (
      this.window.performance.getEntriesByType('navigation').find(p => p !== undefined) as PerformanceNavigationTiming
    )?.type;
    return pageLoadType === 'reload' || pageLoadType === 'back_forward';
  }
}
